<template>
    <UserDataContainer :description="description">
        <form class="user-data-password" @submit.prevent="onSubmit">
            <FormError
                v-if="hasError('generic')"
                :error="getErrorLabel('generic')"
            />

            <FormRow id="password" class="form-row" :error="getErrorLabel('password')">
                <FormInput
                    id="password"
                    v-model="data.password"
                    type="password"
                    placeholder="Password"
                    :error="hasError('password')"
                    @focus="clearError('password')"
                />
            </FormRow>

            <FormRow id="password-confirm" class="form-row" :error="getErrorLabel('passwordConfirm')">
                <FormInput
                    id="password-confirm"
                    v-model="data.passwordConfirm"
                    type="password"
                    placeholder="Confirm Password"
                    :error="hasError('passwordConfirm')"
                    @focus="clearError('passwordConfirm')"
                />
            </FormRow>

            <FormButton
                type="submit"
                class="is-purple"
                :is-loading="isRegistering"
                text="Continue"
            />
        </form>
    </UserDataContainer>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState, mapGetters, mapActions } from 'vuex';

/**
 * Internal dependencies.
 */
import FormButton from '@/components/Form/FormButton';
import FormError from '@/components/Form/FormError';
import FormInput from '@/components/Form/FormInput';
import FormRow from '@/components/Form/FormRow';
import UserDataContainer from './../UserDataContainer';

export default {
    components: {
        FormButton,
        FormError,
        FormInput,
        FormRow,
        UserDataContainer,
    },

    data: () => ({
        description: 'Create a password that includes at least 1 of each of the following: Uppercase letter, number, and special character.',
        data: {
            password: '',
            passwordConfirm: '',
        },
    }),

    computed: {
        ...mapState('register', [
            'isRegistering',
        ]),

        ...mapGetters('register', [
            'getError',
            'hasError',
        ]),
    },

    methods: {
        ...mapActions('register', [
            'updateData',
            'validateData',
            'clearError',
            'clearErrors',
        ]),

        /**
         * Handles form submit.
         */
        async onSubmit() {
            this.clearErrors();

            if (! (await this.validateData(this.data))) {
                return;
            }

            this.updateData(this.data);
            this.$emit('continue');
        },

        /**
         * Gets the label of the field error.
         *
         * @param   {string} field Field name
         * @returns {string}       Error.
         */
        getErrorLabel(field) {
            const error = this.getError(field);

            if ('required' === error) {
                return 'This field is required.';
            }

            if ('confirm' === error) {
                return 'Passwords does not match.';
            }

            return error;
        },
    },
};
</script>
<style scoped lang="scss">
    @use './UserDataPassword.scss';
</style>
